import { JAVA_API_STATUS } from '../../utils/axios-interceptor';
import {
    addLenderRequirement,
    fetchBorrorwerRequirements,
    fetchLenderRequirements,
    updateLenderRequirement as updateLenderRequirementService,
    updateLenderRequirementsBatch as updateLenderRequirementsBatchService,
    updateAicaChaseStatus as updateAicaChaseStatusService,
    updateLenderAicaChaseStatus as updateLenderAicaChaseStatusService,
    refreshRequirementsAsOfToday,
    populateRequestForPnoConfig,
} from './NeedInfoV2Service';
import { UpdateLenderRequirementPayload } from './NeedInfoV2Constants';
import { toast } from 'react-toastify';
import { AicaChaseStatus } from './NeedInfoV2Constants';

// Define the input type for the helper, omitting updatedBy
export const getLenderRequirements = async (payload: { dealId: string; isArchived: boolean }) => {
    try {
        const res = await fetchLenderRequirements(payload);
        if (res.data.responseData.responseCode === JAVA_API_STATUS.SUCCESS) {
            return res?.data?.lenderRequirements;
        } else {
            return false;
        }
    } catch (err) {
        console.error(err);
        return false;
    }
};

export const getBorrowerRequirements = async ({ orgId, pnoId, isArchived }) => {
    try {
        const res = await fetchBorrorwerRequirements({ orgId, pnoId, isArchived });
        if (res.data.responseData.responseCode === JAVA_API_STATUS.SUCCESS) {
            return res.data.borrowerRequirements;
        } else {
            return false;
        }
    } catch (err) {
        console.error(err);
        return false;
    }
};

export const updateLenderRequirement = async (payload: {
    id: number | string;
    updatedBy: string | undefined;
    dataType?: string;
    status?: 'PENDING' | 'COMPLETE';
}) => {
    try {
        const res = await updateLenderRequirementService(payload);
        if (res.data?.responseData?.responseCode === JAVA_API_STATUS.SUCCESS) {
            return true;
        } else {
            return false;
        }
    } catch (err) {
        console.error('Error updating lender requirement:', err);
        return false;
    }
};

export const updateLenderRequirementsBatch = async (payload: {
    ids: (number | string)[];
    updatedBy: string | undefined;
    dataType?: string;
    status?: 'PENDING' | 'COMPLETE';
    isArchived?: boolean;
    isDeleted?: boolean;
    requirementFor?: string;
}) => {
    try {
        const res = await updateLenderRequirementsBatchService(payload);
        if (res.data?.responseData?.responseCode === JAVA_API_STATUS.SUCCESS) {
            return { success: true, data: res.data };
        } else {
            return { success: false, error: res.data?.responseData?.responseMessage || 'Failed to update requirements' };
        }
    } catch (err) {
        console.error('Error updating lender requirements in batch:', err);
        return { success: false, error: 'An error occurred while updating requirements' };
    }
};

export const createLenderRequirement = async (payload: any) => {
    try {
        const res = await addLenderRequirement(payload);
        if (res.data?.responseData?.responseCode === JAVA_API_STATUS.SUCCESS) {
            return true;
        } else {
            return false;
        }
    } catch (err) {
        console.error('Error creating lender requirement:', err);
        return false;
    }
};

export const refreshRequirements = async (payload: any, headers: any) => {
    try {
        const res = await refreshRequirementsAsOfToday(payload, headers);
        if (res.data?.responseData?.responseCode === JAVA_API_STATUS.SUCCESS) {
            return res.data.borrowerRequirements;
        } else {
            return false;
        }
    } catch (err) {
        console.error('Error refreshing requirements  as of today:', err);
        return false;
    }
};

export const addRequestForPnoConfig = async (payload: any) => {
    try {
        const res = await populateRequestForPnoConfig(payload);
        if (res.data?.responseData?.responseCode === JAVA_API_STATUS.SUCCESS) {
            return true;
        } else {
            return false;
        }
    } catch (err) {
        console.error('Error populating request for PNO config:', err);
        return false;
    }
};

export const updateAicaChaseStatus = async (payload: { orgId: string; status: AicaChaseStatus }) => {
    try {
        const res = await updateAicaChaseStatusService(payload);
        if (res.data?.responseData?.responseCode === JAVA_API_STATUS.SUCCESS) {
            return res.data.data;
        } else {
            toast.error(res.data?.responseData?.responseMessage || 'Failed to update AICA chase status');
            return false;
        }
    } catch (err) {
        console.error('Error updating AICA chase status:', err);
        return false;
    }
};

export const updateLenderAicaChaseStatus = async (payload: { dealId: string; status: AicaChaseStatus; lastUpdatedBy: string }) => {
    try {
        const res = await updateLenderAicaChaseStatusService(payload);
        if (res.data?.responseData?.responseCode === JAVA_API_STATUS.SUCCESS) {
            return res.data.data;
        } else {
            toast.error(res.data?.responseData?.responseMessage || 'Failed to update lender AICA chase status');
            return false;
        }
    } catch (err) {
        console.error('Error updating lender AICA chase status:', err);
        return false;
    }
};
